import {
  diseaseCategories,
  costComparisonData,
  trustIndicators,
  testimonials,
  howToOrderSteps,
  paymentGatewayInfo,
  expertConsultationInfo,
  companyLegacy
} from './pharmacyData';

import {
  oncologyHeroData,
  oncologyProducts,
  oncologyCategories,
  oncologyTrustBadges,
  oncologyFAQs,
  oncologyTestimonials,
  oncologySectionContent
} from './oncologyMock';

import {
  hepatitisHeroData,
  hepatitisProducts,
  hepatitisCategories,
  hepatitisTrustBadges,
  hepatitisFAQs,
  hepatitisTestimonials,
  hepatitisSectionContent
} from './hepatitisMock';

import {
  hivHeroData,
  hivProducts,
  hivCategories,
  hivTrustBadges,
  hivFAQs,
  hivTestimonials,
  hivSectionContent
} from './hivMock';

import {
  cardioHeroData,
  cardioProducts,
  cardioCategories,
  cardioTrustBadges,
  cardioFAQs,
  cardioTestimonials,
  cardioSectionContent
} from './cardioMock';

import {
  diabetesHeroData,
  diabetesProducts,
  diabetesCategories,
  diabetesTrustBadges,
  diabetesFAQs,
  diabetesTestimonials,
  diabetesSectionContent
} from './diabetesMock';

import {
  nephrologyHeroData,
  nephrologyProducts,
  nephrologyCategories,
  nephrologyTrustBadges,
  nephrologyFAQs,
  nephrologyTestimonials,
  nephrologySectionContent
} from './nephrologyMock';

import {
  respiratoryHeroData,
  respiratoryProducts,
  respiratoryCategories,
  respiratoryTrustBadges,
  respiratoryFAQs,
  respiratoryTestimonials,
  respiratorySectionContent
} from './respiratoryMock';

import {
  rheumatologyHeroData,
  rheumatologyProducts,
  rheumatologyCategories,
  rheumatologyTrustBadges,
  rheumatologyFAQs,
  rheumatologyTestimonials,
  rheumatologySectionContent
} from './rheumatologyMock';

import {
  neurologyHeroData,
  neurologyProducts,
  neurologyCategories,
  neurologyTrustBadges,
  neurologyFAQs,
  neurologyTestimonials,
  neurologySectionContent
} from './neurologyMock';

import {
  transplantHeroData,
  transplantProducts,
  transplantCategories,
  transplantTrustBadges,
  transplantFAQs,
  transplantTestimonials,
  transplantSectionContent
} from './transplantMock';

import {
  gastroenterologyHeroData,
  gastroenterologyProducts,
  gastroenterologyCategories,
  gastroenterologyTrustBadges,
  gastroenterologyFAQs,
  gastroenterologyTestimonials,
  gastroenterologySectionContent
} from './gastroenterologyMock';

import {
  dermatologyHeroData,
  dermatologyProducts,
  dermatologyCategories,
  dermatologyTrustBadges,
  dermatologyFAQs,
  dermatologyTestimonials,
  dermatologySectionContent
} from './dermatologyMock';

import {
  hematologyHeroData,
  hematologyProducts,
  hematologyCategories,
  hematologyTrustBadges,
  hematologyFAQs,
  hematologyTestimonials,
  hematologySectionContent
} from './hematologyMock';

import {
  infectiousHeroData,
  infectiousProducts,
  infectiousCategories,
  infectiousTrustBadges,
  infectiousFAQs,
  infectiousTestimonials,
  infectiousSectionContent
} from './infectiousMock';

import {
  mentalHealthHeroData,
  mentalHealthProducts,
  mentalHealthCategories,
  mentalHealthTrustBadges,
  mentalHealthFAQs,
  mentalHealthTestimonials,
  mentalHealthSectionContent
} from './mentalHealthMock';

export const defaultSiteData = {
  general: {
    siteName: "MediSeller",
    tagline: "Affordable Life-Saving Medications",
    supportEmail: "support@mediseller.com",
    whatsappNumber: "919876543210",
    yearsInBusiness: 45,
    headerCtaText: "Get Started",
    headerCtaLink: "#contact",
    googleSheetUrl: "https://script.google.com/macros/s/AKfycbzTyYnWd62myTngji98CqbmMSKb21YAZxd2nJswi27W229LeNOgNkKuTaHis1lEE1cMCQ/exec",
    adminPassword: "mediseller@admin2025",
    recoveryEmail: "medisellerwebdev@gmail.com"
  },
  hero: {
    badge: "45 Years Trusted | 50,000+ Patients Worldwide",
    titlePart1: "Save",
    titleHighlight: "Up to 75%",
    titlePart2: "on Life-Saving Medications",
    subtitle: "Access authentic generic medications for Chronic & Terminal Diseases. Licensed pharmacy serving 30+ countries with express delivery.",
    cta1Text: "Browse Medications",
    cta1Link: "#diseases",
    cta2Text: "Upload Prescription",
    cta2Link: "#contact"
  },
  minimalHero: {
    titlePart1: "Affordable Medications for",
    titleHighlight: "Chronic & Terminal Diseases",
    subtitle: "Save up to 75% on life-saving medications. Same quality. Dramatically lower cost.",
    cta1Text: "Browse Diseases",
    cta1Link: "#diseases",
    cta2Text: "Upload Prescription",
    cta2Link: "#contact"
  },
  sections: {
    categoriesHeader: "Browse by Disease Category",
    categoriesSub: "Select your condition to view authentic generic medications with up to 75% savings",
    savingsHeader: "US Patented vs Indian Generic",
    savingsSub: "See exactly how much you can save on your medications with our authentic generic alternatives",
    testimonialsHeader: "Real Patient Stories",
    testimonialsSub: "Hear from patients who transformed their lives with affordable, authentic medications",
    howItWorksHeader: "How It Works",
    howItWorksSub: "Three simple steps to get your medications",
    legacyHeader: "45 Years of Trust & Excellence",
    legacySub: "Our journey from 1980 to serving 50,000+ patients globally",
    consultationHeader: "Get Started Today",
    consultationSub: "Share your prescription and we'll help you save on medications",
    paymentHeader: "Secure Payment Options",
    paymentSub: "Multiple payment methods with bank-level security",
    finalCtaHeader: "Start Your Journey to Affordable Healthcare Today",
    finalCtaSub: "Join 50,000+ patients who've saved millions on life-saving medications",
    qualityPromiseHeader: "Quality You Can Trust",
    qualityPromiseSub: "Every medication is authentic, licensed, and sourced from WHO-certified manufacturers in India"
  },
  footer: {
    description: "Providing affordable access to authentic medications for chronic and terminal diseases since 1980. Licensed international pharmacy serving patients in 30+ countries.",
    link1Text: "Browse Diseases",
    link1Url: "#diseases",
    link2Text: "Cost Savings",
    link2Url: "#savings",
    link3Text: "Contact Us",
    link3Url: "#contact"
  },
  contactForm: {
    nameLabel: "Full Name",
    namePlaceholder: "Your name",
    emailLabel: "Email",
    emailPlaceholder: "your@email.com",
    phoneLabel: "Phone Number",
    phonePlaceholder: "+1 234 567 8900",
    conditionLabel: "Medical Condition",
    conditionPlaceholder: "e.g., Chronic Myeloid Leukemia",
    prescriptionLabel: "Upload Prescription",
    prescriptionSub: "Click to upload",
    prescriptionTypes: "PDF, JPG, PNG (Max 5MB)",
    messageLabel: "Additional Information (Optional)",
    messagePlaceholder: "Any additional details...",
    submitBtnText: "Submit Request",
    responseDisclamer: "We'll respond within 24 hours with pricing and next steps",
    chatPrompt: "Or connect with us directly:",
    chatBtnText: "Chat on WhatsApp"
  },
  qualityPromise: [
    {
      icon: "ShieldCheck",
      title: "100% Authentic",
      desc: "All medications sourced from licensed manufacturers. Full traceability guaranteed."
    },
    {
      icon: "CheckCircle2",
      title: "WHO Certified",
      desc: "Working with WHO-GMP certified Indian pharmaceutical companies trusted globally."
    },
    {
      icon: "Shield",
      title: "45 Years Experience",
      desc: "Serving patients worldwide since 1980. Licensed and fully compliant."
    }
  ],
  howToOrderMinimal: [
    {
      step: 1,
      title: "Send Prescription",
      desc: "Upload your prescription or send via WhatsApp. Our pharmacists will review it."
    },
    {
      step: 2,
      title: "Get Quote & Pay",
      desc: "Receive pricing comparison and complete secure payment online."
    },
    {
      step: 3,
      title: "Receive Medications",
      desc: "Fast delivery to 30+ countries with tracking. Usually 7-14 days."
    }
  ],
  pinnedTestimonial: {
    quote: "\"I was diagnosed with CML and couldn't afford the $8,500 monthly cost in the US. MediSeller provided the same medication for $540. Over 3 years, I've saved over $95,000. This service saved my life and my finances.\"",
    image: "https://i.pravatar.cc/150?img=12",
    author: "Robert T., 58",
    condition: "Cancer Patient, United States",
    statistic: "Saved $95,000+"
  },
  categories: diseaseCategories,
  savings: costComparisonData,
  trustData: trustIndicators,
  patientStories: testimonials,
  orderSteps: howToOrderSteps,
  paymentInfo: paymentGatewayInfo,
  expertInfo: expertConsultationInfo,
  legacyInfo: companyLegacy,

  // Dynamic Category Pages Content
  categoryPages: {
    oncology: {
      hero: oncologyHeroData,
      products: oncologyProducts,
      subCategories: oncologyCategories,
      trustBadges: oncologyTrustBadges,
      faqs: oncologyFAQs,
      testimonials: oncologyTestimonials,
      sectionContent: oncologySectionContent,
      footerMinimal: {
        brandName: "MediSeller",
        copyrightYear: "2025",
        licenseInfo: "All rights reserved. | Licensed International Pharmacy"
      }
    },
    hepatitis: {
      hero: hepatitisHeroData,
      products: hepatitisProducts,
      subCategories: hepatitisCategories,
      trustBadges: hepatitisTrustBadges,
      faqs: hepatitisFAQs,
      testimonials: hepatitisTestimonials,
      sectionContent: hepatitisSectionContent,
      footerMinimal: {
        brandName: "MediSeller",
        copyrightYear: "2025",
        licenseInfo: "All rights reserved. | Licensed International Pharmacy"
      }
    },
    hiv: {
      hero: hivHeroData,
      products: hivProducts,
      subCategories: hivCategories,
      trustBadges: hivTrustBadges,
      faqs: hivFAQs,
      testimonials: hivTestimonials,
      sectionContent: hivSectionContent,
      footerMinimal: {
        brandName: "MediSeller",
        copyrightYear: "2025",
        licenseInfo: "All rights reserved. | Licensed International Pharmacy"
      }
    },
    cardiovascular: {
      hero: cardioHeroData,
      products: cardioProducts,
      subCategories: cardioCategories,
      trustBadges: cardioTrustBadges,
      faqs: cardioFAQs,
      testimonials: cardioTestimonials,
      sectionContent: cardioSectionContent,
      footerMinimal: {
        brandName: "MediSeller",
        copyrightYear: "2025",
        licenseInfo: "All rights reserved. | Licensed International Pharmacy"
      }
    },
    diabetes: {
      hero: diabetesHeroData,
      products: diabetesProducts,
      subCategories: diabetesCategories,
      trustBadges: diabetesTrustBadges,
      faqs: diabetesFAQs,
      testimonials: diabetesTestimonials,
      sectionContent: diabetesSectionContent,
      footerMinimal: {
        brandName: "MediSeller",
        copyrightYear: "2025",
        licenseInfo: "All rights reserved. | Licensed International Pharmacy"
      }
    },
    nephrology: {
      hero: nephrologyHeroData,
      products: nephrologyProducts,
      subCategories: nephrologyCategories,
      trustBadges: nephrologyTrustBadges,
      faqs: nephrologyFAQs,
      testimonials: nephrologyTestimonials,
      sectionContent: nephrologySectionContent,
      footerMinimal: {
        brandName: "MediSeller",
        copyrightYear: "2025",
        licenseInfo: "All rights reserved. | Licensed International Pharmacy"
      }
    },
    respiratory: {
      hero: respiratoryHeroData,
      products: respiratoryProducts,
      subCategories: respiratoryCategories,
      trustBadges: respiratoryTrustBadges,
      faqs: respiratoryFAQs,
      testimonials: respiratoryTestimonials,
      sectionContent: respiratorySectionContent,
      footerMinimal: {
        brandName: "MediSeller",
        copyrightYear: "2025",
        licenseInfo: "All rights reserved. | Licensed International Pharmacy"
      }
    },
    rheumatology: {
      hero: rheumatologyHeroData,
      products: rheumatologyProducts,
      subCategories: rheumatologyCategories,
      trustBadges: rheumatologyTrustBadges,
      faqs: rheumatologyFAQs,
      testimonials: rheumatologyTestimonials,
      sectionContent: rheumatologySectionContent,
      footerMinimal: {
        brandName: "MediSeller",
        copyrightYear: "2025",
        licenseInfo: "All rights reserved. | Licensed International Pharmacy"
      }
    },
    neurology: {
      hero: neurologyHeroData,
      products: neurologyProducts,
      subCategories: neurologyCategories,
      trustBadges: neurologyTrustBadges,
      faqs: neurologyFAQs,
      testimonials: neurologyTestimonials,
      sectionContent: neurologySectionContent,
      footerMinimal: {
        brandName: "MediSeller",
        copyrightYear: "2025",
        licenseInfo: "All rights reserved. | Licensed International Pharmacy"
      }
    },
    gastroenterology: {
      hero: gastroenterologyHeroData,
      products: gastroenterologyProducts,
      subCategories: gastroenterologyCategories,
      trustBadges: gastroenterologyTrustBadges,
      faqs: gastroenterologyFAQs,
      testimonials: gastroenterologyTestimonials,
      sectionContent: gastroenterologySectionContent,
      footerMinimal: {
        brandName: "MediSeller",
        copyrightYear: "2025",
        licenseInfo: "All rights reserved. | Licensed International Pharmacy"
      }
    },
    transplant: {
      hero: transplantHeroData,
      products: transplantProducts,
      subCategories: transplantCategories,
      trustBadges: transplantTrustBadges,
      faqs: transplantFAQs,
      testimonials: transplantTestimonials,
      sectionContent: transplantSectionContent,
      footerMinimal: {
        brandName: "MediSeller",
        copyrightYear: "2025",
        licenseInfo: "All rights reserved. | Licensed International Pharmacy"
      }
    },
    infectious: {
      hero: infectiousHeroData,
      products: infectiousProducts,
      subCategories: infectiousCategories,
      trustBadges: infectiousTrustBadges,
      faqs: infectiousFAQs,
      testimonials: infectiousTestimonials,
      sectionContent: infectiousSectionContent,
      footerMinimal: {
        brandName: "MediSeller",
        copyrightYear: "2025",
        licenseInfo: "All rights reserved. | Licensed International Pharmacy"
      }
    },
    hematology: {
      hero: hematologyHeroData,
      products: hematologyProducts,
      subCategories: hematologyCategories,
      trustBadges: hematologyTrustBadges,
      faqs: hematologyFAQs,
      testimonials: hematologyTestimonials,
      sectionContent: hematologySectionContent,
      footerMinimal: {
        brandName: "MediSeller",
        copyrightYear: "2025",
        licenseInfo: "All rights reserved. | Licensed International Pharmacy"
      }
    },
    dermatology: {
      hero: dermatologyHeroData,
      products: dermatologyProducts,
      subCategories: dermatologyCategories,
      trustBadges: dermatologyTrustBadges,
      faqs: dermatologyFAQs,
      testimonials: dermatologyTestimonials,
      sectionContent: dermatologySectionContent,
      footerMinimal: {
        brandName: "MediSeller",
        copyrightYear: "2025",
        licenseInfo: "All rights reserved. | Licensed International Pharmacy"
      }
    },
    mentalhealth: {
      hero: mentalHealthHeroData,
      products: mentalHealthProducts,
      subCategories: mentalHealthCategories,
      trustBadges: mentalHealthTrustBadges,
      faqs: mentalHealthFAQs,
      testimonials: mentalHealthTestimonials,
      sectionContent: mentalHealthSectionContent,
      footerMinimal: {
        brandName: "MediSeller",
        copyrightYear: "2025",
        licenseInfo: "All rights reserved. | Licensed International Pharmacy"
      }
    }
  }
};
